module.exports = __webpack_public_path__ + "5cfdbd32b3829528a5ba107721274016.png";